import { ensure } from 'components/sharpr/ensure/ensure';

export function bytesToTextFilter() {
	'ngInject';
	const suffixes = ['b', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	return (bytes, precision = 'auto') => {
		let power = 0;
		while (bytes >= 1000) {
			bytes /= 1024;
			power++;
		}
		const num = ensure.finite(bytes);
		if (power === 0) {
			precision = 0;
		} else if (precision == 'auto') {
			if (num > 100) {
				precision = 0;
			} else if (num > 10) {
				precision = 1;
			} else {
				precision = 2;
			}
		}
		return num.toFixed(precision) + ' ' + suffixes[power];
	};
}
